// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_food_grade_status_enum */
var InvFoodGradeStatusEnum;
(function (InvFoodGradeStatusEnum) {
    InvFoodGradeStatusEnum["FOOD_GRADE"] = "FOOD_GRADE";
    InvFoodGradeStatusEnum["NON_FOOD_GRADE"] = "NON_FOOD_GRADE";
    InvFoodGradeStatusEnum["NOT_SPECIFIED"] = "NOT_SPECIFIED";
})(InvFoodGradeStatusEnum || (InvFoodGradeStatusEnum = {}));
;
export default InvFoodGradeStatusEnum;
/** Zod schema for inv_food_grade_status_enum */
export const invFoodGradeStatusEnum = z.nativeEnum(InvFoodGradeStatusEnum);
//# sourceMappingURL=InvFoodGradeStatusEnum.js.map